<template>
  <div :class="_class">
    <slot />
  </div>
</template>
<script>
const name = 'ten-button-group';
export default {
  name,
  props: {
    size: { type: String, validator(v) {
      return ['large', 'default', 'small'].indexOf(v) > -1;
    } },
    disabled: { type: Boolean },
    block: { type: Boolean },
    theme: { type: String, validator(v) {
      return ['default', 'primary', 'text'].indexOf(v) > -1;
    } },
  },
  provide() {
    return {
      buttonGroupProps: this.$props,
    };
  },
  computed: {
    _class() {
      return [`${name}`];
    },
  },
};
</script>
